import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

// Set title for the cell if its text overflows
function tdMouseOverHandler(e) {
    if (
        (e.target.scrollWidth && e.target.scrollWidth > e.target.clientWidth) ||
        (e.target.parentElement.scrollWidth && e.target.parentElement.scrollWidth > e.target.parentElement.clientWidth)
    ) {
        if (e.target.origTitle === undefined) {
            e.target.origTitle = e.target.title ? e.target.title : "";
        }
        e.currentTarget.title = e.currentTarget.innerText;
    }
    else if (e.target.origTitle !== undefined) {
        e.target.title = e.target.origTitle;
    }
}

function SMCTableCell({
    width,
    children,
    align,
    className,
    allowRowWrap
}) {
    const classes = useStyles();

    return (
        <div className={clsx(classes.root, className)} align={align} style={{ width: width }}>
            <span onMouseOver={tdMouseOverHandler} className={classes.content} style={{ whiteSpace: allowRowWrap ? undefined : 'nowrap' }}>
                { children }
            </span>
        </div>
    );
}

const useStyles = makeStyles({
    root: {
        borderLeft: '1px solid transparent',
        boxSizing: 'border-box',
        verticalAlign: 'middle',
        display: 'table-cell',
    },
    content: {
        // paddingLeft: '7px',
        boxSizing: 'border-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // width: 'inherit',
        display: 'block',
        // whiteSpace: 'nowrap',
        width: '-webkit-fill-available',
        '& > span, & > a': {
            paddingLeft: '7px',
            '-webkit-appearance': 'textarea',
            backgroundColor: 'inherit',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: 'inherit',
            // whiteSpace: 'nowrap'    
        },
        paddingTop: '4px',
        paddingBottom: '4px',
    }
})

SMCTableCell.propTypes = {
    width: PropTypes.number,
    align: PropTypes.string,
    className: PropTypes.string,
    allowRowWrap: PropTypes.bool
}

export default React.memo(SMCTableCell);